import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useSearchParams } from "next/navigation";
import { DropdownButton, DropdownItem, Row } from "@/utils/bootstrap";
import SortDropdownTitle from "./SortDropdownTitle";
import { usePushQueryToRouter } from "@/utils/functions/pushQueryToRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";
export enum SortTypes {
  products = "products",
  orders = "orders",
  appointments = "appointments",
  applications = "applications",
}

interface Props {
  isPC?: boolean;
  type: SortTypes;
  backdrop?: boolean;
}
const SortDropdown: React.FC<Props> = ({
  isPC = false,
  type,
  backdrop = false,
}) => {
  const pushQueryToRouter = usePushQueryToRouter();
  const searchParams = useSearchParams();
  const { data } = useGetCompanyQuery();
  const sortTypes = () => {
    switch (type) {
      case SortTypes.appointments:
        return data?.result?.sort_types?.appointments ?? [];
      case SortTypes.orders:
        return data?.result?.sort_types?.orders ?? [];
      case SortTypes.products:
        return data?.result?.sort_types?.products ?? [];
      case SortTypes.applications:
        return data?.result?.sort_types?.applications ?? [];
      default:
        return null;
    }
  };
  const sortType = sortTypes()
  const t = useTranslation()
  const currSortType = searchParams?.get("filter")
  return (
    <div
      className={`sort-dropdown${isPC ? "" : "-mobile"} ${
        backdrop ? "dropdown-backpage" : ""
      }`}
    >
      <DropdownButton
        variant="outline"
        onSelect={(e) =>
          pushQueryToRouter.pushQueryToRouter(
            [{ name: "filter", val: e }],
            true
          )
        }
        title={
          <SortDropdownTitle
            title={
             sortType?.find((st) => st.key === currSortType)?.value ?? t.chooseTheSorting
            }
          />
        }
      >
        {sortTypes()?.map((sortType, key) => (
          <DropdownItem
            active={sortType?.key === currSortType}
            key={key}
            eventKey={sortType?.key}
          >
            <Row className="m-0">{sortType?.value}</Row>
          </DropdownItem>
        ))}
      </DropdownButton>
    </div>
  );
};

export default SortDropdown;
